import React from 'react'
import './Registro.css'
import { useState,useEffect} from 'react';

const Registro = ({setName}) =>{
    const [msje, setMsje] = useState(null)
    const [msje2, setMsje2] = useState(null)
    const [counter, setCounter] = useState(0)
    const [saved, setSaved] = useState(false)

    const compare = (json,source)=>{
         setCounter(counter+1)
        if(source === "record"){
            if(json.auth === true){ 
                setMsje("Se envió un correo para completar el proceso de registro") 
                alert("Se envió un correo para completar el proceso de registro") 
                setSaved(true)
            }
            else{
                setMsje(json.error)
            }
        }
        if(source === "recover"){
            if(json.auth === true){ 
                setMsje2("Se envió la clave a su correo.")
            }
            else{
                setMsje2(json.error)
            }
        }
    }
/*
    useEffect(() => {
        //console.log("s: "+ saved)
        if(saved == true){
            const timeout2 = setTimeout(() => {
                setName('nitro')
              }, 5000)
              return () => clearTimeout(timeout2) 
        }  
    },[saved]);
*/

    useEffect(() => {
        //console.log("n: "+ counter)
        if(counter > 3){
            setName('loader')
            setTimeout(() => {
                setName('nitro')
                //console.log("--")
              }, 30000); 
        }  
    },[counter]);


    function handleSubmit(e) {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
        let url = "http://localhost/react_projects/ISIGHT/src/api/registro/index.php"
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        } else {url = "api/registro/index.php"}
        const formJson = Object.fromEntries(formData.entries());
        if(formJson.mail === '' || formJson.name === '' || formJson.lastname === ''){
            setMsje("Debe completar todos los campos")
            return
        }
        if(formJson.mail === ''){
            setMsje("Debe completar el campo")
            return
        }
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formJson.mail)) {
            setMsje("Formato de correo incorrecto")
            return
        }
        ///^[A-Z0-9]{4,6}/gmi
        if (!/^[A-Z0-9]{4,10}$/gmi.test(formJson.pass)) {
            setMsje(<span><p>{"Solo letras y/o numeros"}</p><p>{"De 4 a 10 caracteres"}</p></span>)
            return
        }
        else{
            setMsje(<span><p style={{color:'#99ff99'}}>{"Enviando..."}</p></span>)
        }
        fetch(url,{method:"POST",body:JSON.stringify({
            mail: formJson.mail,
            name: formJson.name,
            lastname: formJson.lastname,
            pass: formJson.pass,
            task:'record'
        }),headers:{"Content-Type":"application/json"}}).then(function(i){return i.json()})
        .then(function(i){
            compare(i,'record')
        })
        .catch(function(i){
            console.log("Error \n"+i)
        })
    }

    function handleSubmit2(e) {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
        let url = "http://localhost/react_projects/ISIGHT/src/api/registro/index.php"
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        } else {url = "api/registro/index.php"}
        const formJson = Object.fromEntries(formData.entries());
        if(formJson.mail === ''){
            setMsje2("Debe completar el campo")
            return
        }
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formJson.mail)) {
            setMsje2("Formato de correo incorrecto")
            return
        }
        
        
        fetch(url,{method:"POST",body:JSON.stringify({
            'task':'recover',
            'mail': formJson.mail
        }),headers:{"Content-Type":"application/json"}}).then(function(i){return i.json()})
        .then(function(i){
        compare(i,'recover')
        })
        .catch(function(i){
        console.log("Error de session \n"+i)
        })
    }
    
   const backHandler = ()=>{
    setName('nitro') 
    setCounter(0)
   }

    return(
        <div className="body">

    <div className="out-square euro backbutton"  onClick={backHandler}>Volver</div>


    <div className="form-container">
		<form autoComplete="off" className="out-square form-registro" onSubmit={handleSubmit}>  
			<div className="form-logo euro">REGISTRO</div>
			<div className="input-holder-reg">
                <input autoComplete="off" name="mail" className="form-input-registro" type="text"  placeholder="  Correo corporativo (BHP)"  required=""/>
                <input autoComplete="off" name="name" className="form-input-registro" type="text"  placeholder="  Nombre"  required=""/>
                <input autoComplete="off" name="lastname" className="form-input-registro" type="text"  placeholder="  Apellidos"  required=""/>
                <input autoComplete="off" name="pass" className="form-input-registro" type="password"  placeholder="  Password"  required=""/>
            </div>
			<button className="out-square form-btn-reg euro" type="submit">Enviar</button>
			<div><small style={{color: '#4d6ae2'}} id="msje"></small></div>
            <div className="bottom-msje-reg">{msje}</div>
			<div className="power">Powered by Mine Blaster</div>
		</form>
	</div>

    <div className="form-container">
		<form autoComplete="off" className="out-square form-recover" onSubmit={handleSubmit2}>  
			<div className="form-logo-recover euro">RECUPERAR CLAVE</div>
			<div className="input-holder">
                <input autoComplete="off" name="mail" className="form-input-registro" type="text"  placeholder="  Correo corporativo (BHP)"  required=""/>
            </div>
			<button className="out-square form-btn euro" type="submit">Enviar</button>
			<div><small style={{color: '#4d6ae2'}} id="msje"></small></div>
            <div className="bottom-msje">{msje2}</div>
			<div className="power">Powered by Mine Blaster</div>
		</form>
	</div>
    </div>
    )
}

    export default Registro


